import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SourceEnum } from 'src/app/enums/source.enum';
import { IRequiredValidators } from 'src/app/interfaces/required-validators.interface';
import { SourceService } from 'src/app/services/source.service';

@Component({
  selector: 'app-presentation-screen',
  templateUrl: './presentation-screen.component.html',
  styleUrls: ['./presentation-screen.component.scss'],
})
export class PresentationScreenComponent {
  requiredValidator!: IRequiredValidators;
  isAvancecred = false;
  isAvancecredSubdomain = false;
  avancecredInitialImageUrl = '/assets/webp/avancecred/principal.webp';

  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private sourceService: SourceService
  ) {
    this.setRequiredValidators();
  }

  navigatePreRegister() {
    if (this.isAvancecredSubdomain) {
      this.router.navigate(['/cedente/register']);
      return;
    }
    this.router.navigate(['./register'], { relativeTo: this.activatedRoute });
  }

  private setRequiredValidators() {
    const source = this.sourceService.getSource();
    const subdomainSource = this.sourceService.getSourceBySubdomain();

    this.isAvancecredSubdomain =
      subdomainSource?.toLowerCase() === SourceEnum.AVANCECRED;
    this.isAvancecred = source?.toLowerCase() === SourceEnum.AVANCECRED;
    this.requiredValidator = this.sourceService.isRequired(source);

    if (this.isAvancecredSubdomain && window.location.pathname.includes('/cedente/avancecred')) {
      this.router.navigate(['/cedente'], { replaceUrl: true });
    }
  }
}
